import { createSlice } from '@reduxjs/toolkit';
import { getAllLoans, getSessionLoans, getUserLoan } from './thunks';
// Initial state for Redux store:
export const initialStateLoans = {
  loans: {
    total: 0,
    loans: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  userLoan: {},
  sessionLoans: {},
  loading: false,
};

const loansSlice = createSlice({
  name: 'loans',
  initialState: initialStateLoans, // Define initial state
  reducers: {
    setLoans: (state: any, action: any) => {
      state.loans = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllLoans.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllLoans.fulfilled, (state, action) => {
      state.loans = action.payload;
      state.loading = false;
    });
    builder.addCase(getUserLoan.fulfilled, (state, action) => {
      state.userLoan = action.payload;
    });
    builder.addCase(getSessionLoans.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSessionLoans.fulfilled, (state, action) => {
      state.loading = false;
      state.sessionLoans = action.payload;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setLoans } = loansSlice.actions;

// Export reducer generated by "createSlice()":
export default loansSlice.reducer;
